import { SimpleForm, TextInput, required, SelectInput, Edit, useDataProvider, DateInput, Toolbar, SaveButton, TopToolbar } from 'react-admin';
import { useEffect, useState } from 'react';
import BackButton from '../../Components/BackButton';


// 添加电话号码校验
const validatePhone = (value: string) => {
    const phoneRegex = /^1[3-9]\d{9}$/;
    if (!phoneRegex.test(value)) {
        return '请输入有效的手机号码';
    }
    return undefined;
};

const validateCashRevenueShare = (value: string) => {
    const numValue = parseFloat(value);

    if (isNaN(numValue)) {
        return '请输入有效的数字';
    }

    if (numValue < 0) {
        return '分成占比不能为负数';
    }

    if (numValue > 100) {
        return '分成占比不能超过100%';
    }

    return undefined;
};


const ActionsToolbar = () => (
    <TopToolbar sx={{ justifyContent: 'start' }}>
        <BackButton />
    </TopToolbar>
);

const PostEditToolbar = () => (
    <Toolbar>
        <SaveButton />
    </Toolbar>
);


export const DeviceAccountEdit = () => {
    const dataProvider = useDataProvider(); // 获取dataProvider
    const [customerTypeChoices, setCustomerTypeChoices] = useState([]);
    useEffect(() => {
        // 异步获取客户类型数据
        const fetchCustomerTypes = async () => {
            try {
                const types = await dataProvider.getCustomerTypes();
                setCustomerTypeChoices(types);
            } catch (error) {
                console.error("获取客户类型失败:", error);
            }
        };

        fetchCustomerTypes();
    }, []);  // 空依赖数组确保只调用一次

    return (
        <Edit actions={<ActionsToolbar />} mutationMode="optimistic">
            <SimpleForm sx={{ width: { lg: '40%', xs: '100%' } }} toolbar={<PostEditToolbar />}>
                {/* <TextInput label="商城账号id" source="id" validate={[required()]} /> */}
                <TextInput label="客户名称" source="name" validate={[required()]} />
                <SelectInput
                    alwaysOn
                    source="customerTypeId"
                    label="客户类型"
                    choices={customerTypeChoices}
                />
                <TextInput label="负责人" source="manager" validate={[required()]} />
                <TextInput label="联系电话" source="contactPhone" validate={[required(), validatePhone]} />
                <DateInput
                    label="合同结束日期"
                    source="contractEndDate"
                    validate={[required()]}
                />
                <TextInput label="分成占比%" source="cashRevenueShare" validate={[validateCashRevenueShare]} />
            </SimpleForm>
        </Edit>
    )
};